import React from "react";
import { Text } from "@bookingcom/bui-react";

type DisclaimersProps = {
  disclaimers: string[];
};

export const Disclaimers = ({ disclaimers }: DisclaimersProps) => {
  if (disclaimers.length === 0) {
    return null;
  }

  return (
    <div>
      {disclaimers.map((disclaimer, index) => (
        <Text variant="small_2" color="neutral_alt" key={`kDisclaimer_${index}`}>
          {disclaimer}
        </Text>
      ))}
    </div>
  );
};
